/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-assistant.reducer';

export const HospitalAssistantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalAssistantEntity = useAppSelector(state => state.hospitalAssistant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalAssistantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalAssistant.detail.title">HospitalAssistant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.name">Name</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.email">Email</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.email}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.age">Age</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.age}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.bloodGroup}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.cursor}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.education">Education</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.training">Training</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.achievements}</dd>
          <dt>
            <span id="tmExternal">
              <Translate contentKey="tinyMedicRestApp.hospitalAssistant.tmExternal">Tm External</Translate>
            </span>
          </dt>
          <dd>{hospitalAssistantEntity.tmExternal ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAssistant.tmUser">Tm User</Translate>
          </dt>
          <dd>{hospitalAssistantEntity.tmUser ? hospitalAssistantEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAssistant.contactCode">Contact Code</Translate>
          </dt>
          <dd>{hospitalAssistantEntity.contactCode ? hospitalAssistantEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAssistant.hospital">Hospital</Translate>
          </dt>
          <dd>{hospitalAssistantEntity.hospital ? hospitalAssistantEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-assistant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-assistant/${hospitalAssistantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalAssistantDetail;
